






try {
    const importAll = (requireContext: __WebpackModuleApi.RequireContext) => requireContext.keys().forEach(requireContext)
    importAll(require.context("../assets/icons",true,/\.svg$/))
}catch (e) {
    console.log(e)
}
export default {
    props: ['name'],
    name: 'Icon'
};
